import {useState, useEffect} from "../../__snowpack__/pkg/react.js";
import {axios} from "../lib/axios.js";
import {handleError} from "../lib/errorHandler.js";
export const useOptionsFromApi = ({
  url,
  formatMessage,
  method = "get",
  params,
  getOptionFromDataItem
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data} = await axios.request({
        url,
        method,
        ...method === "get" && params ? {params} : null,
        ...method === "post" && params ? {data: params} : null
      });
      setOptions((Array.isArray(data) ? data : Array.isArray(data.content) ? data.content : []).map((item) => {
        const option = getOptionFromDataItem ? getOptionFromDataItem(item) : item;
        if (formatMessage) {
          return {...option, label: formatMessage({id: option.label})};
        } else {
          return option;
        }
      }));
      return data;
    } catch (error) {
      handleError(error);
      return error;
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return {
    loading,
    options,
    fetchData
  };
};
